import React from "react";
import resumePdf from "../assets/resume.pdf";
import useReveal from "./useReveal";

function MailIcon() {
  return React.createElement(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    React.createElement("rect", {
      x: "2",
      y: "4",
      width: "20",
      height: "16",
      rx: "2",
    }),
    React.createElement("path", {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
    }),
  );
}

function LinkedInIcon() {
  return React.createElement(
    "svg",
    { width: "18", height: "18", viewBox: "0 0 24 24", fill: "currentColor" },
    React.createElement("path", {
      d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 11.268h-3v-5.604c0-1.337-.026-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.967v5.7h-3v-10h2.881v1.367h.041c.401-.761 1.379-1.563 2.841-1.563 3.039 0 3.6 2.001 3.6 4.601v5.595z",
    }),
  );
}

function GitHubIcon() {
  return React.createElement(
    "svg",
    { width: "18", height: "18", viewBox: "0 0 24 24", fill: "currentColor" },
    React.createElement("path", {
      d: "M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.083-.729.083-.729 1.205.085 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.108-.775.418-1.305.762-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.468-2.38 1.236-3.22-.124-.303-.535-1.523.117-3.176 0 0 1.008-.322 3.3 1.23a11.5 11.5 0 0 1 3-.404c1.02.005 2.045.138 3 .404 2.29-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.873.12 3.176.77.84 1.235 1.91 1.235 3.22 0 4.61-2.803 5.625-5.475 5.92.43.37.823 1.102.823 2.222 0 1.606-.015 2.898-.015 3.293 0 .322.218.694.825.576C20.565 21.796 24 17.297 24 12c0-6.63-5.37-12-12-12z",
    }),
  );
}

function DownloadIcon() {
  return React.createElement(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
    },
    React.createElement("path", { d: "M12 3v12m0 0l-4-4m4 4l4-4M4 21h16" }),
  );
}

function Contact() {
  const [ref, inView] = useReveal();

  return React.createElement(
    "section",
    {
      id: "contact",
      ref: ref,
      className: "contact section reveal" + (inView ? " in-view" : ""),
    },
    React.createElement("p", { className: "eyebrow" }, "05 \u2014 Contact"),
    React.createElement("h2", { className: "section-title" }, "Work with me!"),
    React.createElement(
      "div",
      { className: "contact-links" },
      React.createElement(
        "a",
        { href: "mailto:carlo.labanan@gmail.com", className: "contact-link" },
        React.createElement(MailIcon),
        "carlo.labanan@gmail.com",
      ),
      React.createElement(
        "a",
        {
          href: "https://www.linkedin.com/in/van-carlo-labanan-54b0312b0",
          target: "_blank",
          rel: "noopener noreferrer",
          className: "contact-link",
        },
        React.createElement(LinkedInIcon),
        "LinkedIn",
      ),
      React.createElement(
        "a",
        {
          href: "https://github.com/VanCarlo95",
          target: "_blank",
          rel: "noopener noreferrer",
          className: "contact-link",
        },
        React.createElement(GitHubIcon),
        "GitHub",
      ),
      React.createElement(
        "a",
        {
          href: resumePdf,
          download: "Van_Carlo_Labanan_Resume.pdf",
          className: "contact-link contact-link-accent",
        },
        React.createElement(DownloadIcon),
        "Download R\u00E9sum\u00E9",
      ),
    ),
  );
}

export default Contact;
